class UtmModel {
  constructor({
    utm_source = null,
    utm_medium = null,
    utm_campaign = null,
    utm_term = null,
    utm_content = null,
  } = {}) {
    this.utm_source = utm_source;
    this.utm_medium = utm_medium;
    this.utm_campaign = utm_campaign;
    this.utm_term = utm_term;
    this.utm_content = utm_content;
  }

  json() {
    return {
      utm_campaign: this.utm_campaign,
      utm_content: this.utm_content,
      utm_medium: this.utm_medium,
      utm_source: this.utm_source,
      utm_term: this.utm_term,
    };
  }

  list() {
    let utm = Object.keys(this);
    let list = [];
    for (let property of utm) {
      list.push({
        key: property,
        value: this[property],
      });
    }
    return list;
  }
}
module.exports = UtmModel;
